<template>
    <div class="comparable-listing" v-if="comparableList.length > 0">
        <div class="comparable-listing-title">
            {{
                reportJSON.houseLow && reportJSON.houseHigh
                    ? $t('md-evaluation-banner.nearbyHomeWithin', {
                        houseLow: $ft.formatCurrency({
                            value: reportJSON.houseLow,
                            noSpace: true,
                            units: true,
                            blank: undefined,
                            fixedLength: 2,
                            currencySymbol
                        }),
                        houseHigh: $ft.formatCurrency({
                            value: reportJSON.houseHigh,
                            noSpace: true,
                            units: true,
                            blank: undefined,
                            fixedLength: 2,
                            currencySymbol
                        })
                    })
                    : $t('md-evaluation-banner.nearbyHome')
            }}
        </div>
        <HouseGrid
            v-bind="$attrs"
            :houses="comparableList"
            class="full-screen"
            :isInMap="false"
            :showCheckbox="false"
        />
        <div class="more-listing" v-if="comparableList.length >= 3">
            <a
                target="_blank"
                :href="more.link"
                style="background-color: var(--color-theme)"
                rel="noopener noreferrer"
            >{{ $t('md-evaluation-banner.moreListings') }}</a>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import { getAsyComponent } from '@/common/utils/load-module.js';

export default {
    name: 'HomeValuationNearByListings',
    i18next: {
        ns: 'md-evaluation-banner'
    },
    components: {
        HouseGrid: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/grid-v3_grid"*/ '@/modules/md-house/grid-v3/grid.vue'
            ))
    },
    computed: {
        ...rootMapState(usePageStore, {
            "currencySymbol": store => store.currency?.symbol
        }),
        
    },
    props: {
        comparableList: {
            type: Array,
            default: () => []
        },
        reportJSON: {
            type: Object,
            default: () => ({})
        },
        more: {
            type: Object,
            default: () => ({})
        }//{bgColor, link}
    }
};
</script>
<style lang="scss"></style>
